function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "94EA2F9B-7491-427B-8103-D4431723F2BE");

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Price-Inner-Page---New-Row---Select-brand",
  transform: "translate(-443.000000, -509.000000)"
}, React.createElement("g", {
  id: "brand-dropdown",
  transform: "translate(306.000000, 493.000000)"
}, React.createElement("g", {
  id: "Atoms-/-Form-/-Field-/-icon_right",
  transform: "translate(8.000000, 8.000000)"
}, React.createElement("g", {
  id: "Group-2",
  transform: "translate(129.000000, 8.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}), React.createElement("g", {
  id: "icon",
  transform: "translate(2.666667, 3.666667)",
  fillRule: "nonzero",
  stroke: "#C2D1D9",
  strokeWidth: 1.33333333
}, React.createElement("path", {
  d: "M4.66666667,9.33333333 C7.2439955,9.33333333 9.33333333,7.2439955 9.33333333,4.66666667 C9.33333333,2.08933783 7.2439955,0 4.66666667,0 C2.08933783,0 0,2.08933783 0,4.66666667 C0,7.2439955 2.08933783,9.33333333 4.66666667,9.33333333 Z M7.95924167,7.95924167 L10.6666667,10.6666667",
  id: "Combined-Shape"
})))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/select_search_icon.53d48c2a.svg";
export { SvgComponent as ReactComponent };